import React, { Fragment, Component } from 'react'
import { Post, AxiosProvider } from 'react-axios'
import axios from 'axios'
import { setStoredItem, getStoredItem } from '../../../../modules/stored-item'
import { StyledCircularProgress0LoginForm, StyledErrorText0LoginForm } from '../LoginForm'
import translate from '../../../../modules/translate'
import { login } from '../../../../modules/login'
import Config from '../../../../config'
import { createUuid, getUS } from '../../../../modules/uuid'

const uuid = createUuid()
const s = uuid + 'pm97cLnLIdqI0GueUozSUZexw1iNZ5WEfVqYz5uX7PGw'
class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      accessTokenMustBeRefreshed: false,
      isUserLoggedIn: false,
    }
  }
  render() {
    const { showError, showProgress, username, password } = this.props
    let getAuthTokenDataString =
      'scope=*&client_id=1&client_secret=' +
      getUS(s, uuid) +
      '&grant_type=password&username=' +
      username +
      '&password=' +
      password
    let getAuthTokenAxiosInstance = axios.create({
      headers: {
        Accept: 'application/json',
      },
    })
    return (
      <Fragment>
        {getStoredItem('user') === null && (
          <AxiosProvider instance={getAuthTokenAxiosInstance}>
            <Post url={Config.authUrl('token')} data={getAuthTokenDataString}>
              {(error, response, isLoading) => {
                if (response && response.status === 200) {
                  setStoredItem('access_token', response.data.access_token, true)
                  setStoredItem('access_token_expires_in', response.data.expires_in, true)
                  setStoredItem('refresh_token', response.data.refresh_token, true)
                  login(response.data.user, this.props.callBackAfterLogin)
                  return <Fragment />
                } else if (isLoading && showProgress) {
                  return (
                    <Fragment>
                      <StyledCircularProgress0LoginForm />
                    </Fragment>
                  )
                } else if (error && showError) {
                  return (
                    <StyledErrorText0LoginForm>
                      {error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : translate('login_try_error')}
                    </StyledErrorText0LoginForm>
                  )
                }
                return <div></div>
              }}
            </Post>
          </AxiosProvider>
        )}
      </Fragment>
    )
  }
}

Login.defaultProps = {
  callBackAfterLogin: () => {},
  showProgress: true,
  showError: true,
  username: '',
  password: '',
}

export default Login
